module.exports = __webpack_public_path__ + "static/media/silver-badge.dfe6fa5b.svg";